import { useOwnershipTranslations } from '../../../../hooks/useOwnershipTranslation';
import { TooltipTitle as TooltipTitleContainer } from './styled';
import { useMemo } from 'react';

interface Props {
  type: 'bought' | 'sold';
  total: number;
  individualCount: number;
  companyCount: number;
  totalValue: string;
}

function getTranslationParams(
  type: 'buy' | 'sell',
  individualCount: number,
  companyCount: number
) {
  if (
    (individualCount === 1 && companyCount === 1) ||
    (individualCount > 1 && companyCount === 1)
  ) {
    return {
      key: `insiderTradingVolume.${type}.tooltip.individuals_company`,
      options: {
        count: individualCount,
        cCount: companyCount,
      },
    } as const;
  } else if (individualCount === 1 && companyCount > 1) {
    return {
      key: `insiderTradingVolume.${type}.tooltip.individual_companies_other`,
      options: {
        iCount: individualCount,
        count: companyCount,
      },
    } as const;
  } else {
    return {
      key: `insiderTradingVolume.${type}.tooltip.individuals_companies`,
      options: {
        iCount: individualCount,
        cCount: companyCount,
      },
    } as const;
  }
}
export function TooltipTitle({
  type,
  total,
  individualCount,
  companyCount,
  totalValue,
}: Props) {
  const t = useOwnershipTranslations();
  const tooltipText = useMemo(() => {
    let text = '';
    if (type === 'bought') {
      if (individualCount > 0 && companyCount === 0) {
        text += t('insiderTradingVolume.buy.tooltip.individual', {
          total: total.toLocaleString(),
          count: individualCount,
        });
      } else if (individualCount === 0 && companyCount > 0) {
        text += t('insiderTradingVolume.buy.tooltip.company', {
          total: total.toLocaleString(),
          count: companyCount,
        });
      } else {
        const { key, options } = getTranslationParams(
          'buy',
          individualCount,
          companyCount
        );
        text += t(key, { total: total.toLocaleString(), ...options });
      }
    } else if (type === 'sold') {
      if (individualCount > 0 && companyCount === 0) {
        text += t('insiderTradingVolume.sell.tooltip.individual', {
          total: total.toLocaleString(),
          count: individualCount,
        });
      } else if (individualCount === 0 && companyCount > 0) {
        text += t('insiderTradingVolume.sell.tooltip.company', {
          total: total.toLocaleString(),
          count: companyCount,
        });
      } else {
        const { key, options } = getTranslationParams(
          'sell',
          individualCount,
          companyCount
        );
        text += t(key, { total: total.toLocaleString(), ...options });
      }
    }
    return (
      text +
      ' ' +
      t('insiderTradingVolume.valueAt', {
        totalValue,
      })
    );
  }, [type, total, individualCount, companyCount, totalValue, t]);

  return <TooltipTitleContainer>{tooltipText}</TooltipTitleContainer>;
}
